import React from 'react';
import { IResourceComponentsProps, useShow } from '@refinedev/core';
import { Show, NumberField, TextField, DateField } from '@refinedev/antd';
import { Typography } from 'antd';

const { Title } = Typography;

export const GameCategoryShow: React.FC<IResourceComponentsProps> = () => {
  const { queryResult } = useShow();
  const { data, isLoading } = queryResult;

  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>Id</Title>
      <NumberField value={record?.id ?? ''} />
      <Title level={5}>Name</Title>
      <TextField value={record?.name} />
      <Title level={5}>Sort</Title>
      <NumberField value={record?.sort ?? ''} />
      <Title level={5}>Created at</Title>
      <DateField value={record?.createdAt} />
      <Title level={5}>Updated at</Title>
      <DateField value={record?.updatedAt} />
    </Show>
  );
};
